import { Environment as Env } from './prod.environment';
import { dev } from './data.environment';

export class Environment extends Env {
  static override readonly production: boolean = false;
  static override readonly urlAPI: string = 'https://aws-dev-wag-api.azurewebsites.net/';
  static override readonly urlAPIStable: string = 'https://aws-dev-stable-api.azurewebsites.net/';
  static override readonly enableAnalytics: boolean = false;
  static override readonly enableDevToolsRedux: boolean = true;
  static override readonly enableComponentView: boolean = true;
  static override readonly environment: string = 'development';
  static override readonly pusher = {
    key: dev?.pusher?.key,
    cluster: 'us2',
    beams: {
      instanceId: dev?.pusher?.beams?.instanceId,
      secretKey: ''
    }
  };
  static override readonly eProtect = {
    url: 'https://request.eprotect.vantivprelive.com/eProtect/js/eProtect-iframe-client3.min.js',
    jQuery: 'https://ajax.googleapis.com/ajax/libs/jquery/1.4.2/jquery.min.js',
    css: 'test',
    reportGroup: 'AmWagerPro'
  };
  static override readonly smartlook: string = '';
}
